<template>
<div class="login-container">
  <div class="login-background">
    <div class="login-page-title">会员管理系统
    </div>
    <div class="login-input-content">
      <div class="login-input-content-bg" v-if="showLoginOrSignUp === true">
        <div class="login-title">用户登录</div>
        <el-form label-position="left" ref="form">
          <el-form-item v-if="loginType === 0" label="账号" class="form-input" label-width="50px" prop="account">
            <el-input v-model="account" placeholder="请输入手机号"  @keyup.enter.native="accountEnter"/>
          </el-form-item>
          <el-form-item v-if="loginType === 1" label="手机号" class="form-input" label-width="60px">
            <el-input v-model="account" placeholder="请输入手机号" @keyup.enter.native="loginBySmsAccountEnter"/>
          </el-form-item>
          <el-form-item v-if="loginType === 0" label="密码" class="form-input" label-width="50px">
            <el-input v-model="password" placeholder="请输入密码" show-password ref="pswInput" @keyup.enter.native="login"/>
          </el-form-item>
          <el-form-item v-if="loginType === 1" label="验证码" label-width="60px">
            <el-input style="width: 8rem" v-model="smsCode" placeholder="请输入验证码" ref="smsCodeInput" @keyup.enter.native="login"/>
            <el-button type="primary" size="medium" style="margin-left: 1rem; width: 7rem" :disabled="smsCodeCountDownSecond > 0" :loading=loading @click="sendLoginSMSCode">{{smsCodeCountDownSecond > 0? ('' + smsCodeCountDownSecond) : '发送验证码'}}</el-button>
          </el-form-item>
          <el-form-item size="large" label-width="0px">
            <el-button  style="width: 19.5rem; margin-left: 0.5rem" size="medium" type="primary" @click="login" :loading="loading">登录</el-button>
          </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: space-between">
          <el-button type="text" :disabled="loading"  @click="switchLoginType">{{loginType === 0?'验证码登录':'密码登录'}}</el-button>
          <el-button type="text" :disabled="loading" @click="switchLoginOrSignUp">注册</el-button>
        </div>
      </div>
      <div class="login-input-content-bg" v-if="showLoginOrSignUp === false">
        <div class="login-title">用户注册</div>
        <el-form label-position="left">
          <el-form-item  label="手机号" class="form-input" label-width="60px">
            <el-input v-model="account" placeholder="请输入手机号" @keyup.enter.native="registerAccountEnter"/>
          </el-form-item>
          <el-form-item label="验证码" label-width="60px">
            <el-input style="width: 8rem" v-model="smsCode" placeholder="请输入验证码" ref="registerSMSCodeInput" @keydown.enter.native="registerSMSCodeEnter"/>
            <el-button type="primary" size="medium" style="margin-left: 1rem; width: 7rem" :disabled="smsCodeCountDownSecond > 0" :loading=loading @click="sendRegisterSMSCode">{{smsCodeCountDownSecond > 0? ('' + smsCodeCountDownSecond) : '发送验证码'}}</el-button>
          </el-form-item>
          <el-form-item label="密码" class="form-input" label-width="60px">
            <el-input v-model="password" placeholder="请输入密码" show-password @keydown.enter.native="registerAction" ref="registerPswInput"/>
          </el-form-item>
          <el-form-item size="large" label-width="0px">
            <el-button style="width: 19.5rem; margin-left: 0.5rem" size="medium" type="primary" @click="registerAction" :loading="loading">注册</el-button>
          </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: space-between">
          <div/>
          <el-button type="text" :disabled="loading" @click="switchLoginOrSignUp">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {loginByPhone, loginBySMSCode, postRegisterInfo, sendLoginSMSCode, sendRegisterSMSCode} from './loginApi'

export default {
  name: 'index',
  data () {
    return {
      account: '',
      password: '',
      smsCode: '',
      smsCodeCountDownSecond: -1,
      loginType: 0, // 0 密码 1 验证码
      showLoginOrSignUp: true, // true 登录 false 注册
      loading: false
    }
  },
  methods: {
    login () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      if (this.loginType === 0) {
        const psw = this.password.trim()
        if (psw.length === 0) {
          this.$message.error('密码不能为空')
          return
        }
        this.loading = true
        loginByPhone(phone, psw).then(rsp => {
          const {code, message} = rsp
          this.loading = false
          if (code === 0) {
            this.loginSuccess()
          } else {
            this.$message.error(message)
          }
        })
      } else if (this.loginType === 1) {
        const smsCode = this.smsCode.trim()
        if (smsCode.length === 0) {
          this.$message.error('验证码不能为空')
          return
        }
        this.loading = true
        loginBySMSCode(phone, smsCode).then(rsp => {
          const {code, message} = rsp
          this.loading = false
          if (code === 0) {
            this.loginSuccess()
          } else {
            this.$message.error(message)
          }
        })
      }
    },
    accountEnter () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      this.$refs.pswInput && this.$refs.pswInput.focus()
    },
    loginBySmsAccountEnter () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      this.$refs.smsCodeInput && this.$refs.smsCodeInput.focus()
    },
    registerAccountEnter () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      this.$refs.registerSMSCodeInput && this.$refs.registerSMSCodeInput.focus()
    },
    registerSMSCodeEnter () {
      const smsCode = this.smsCode.trim()
      if (smsCode.length === 0) {
        this.$message.error('验证码不能为空')
        return
      }
      this.$refs.registerPswInput && this.$refs.registerPswInput.focus()
    },
    loginSuccess () {
      const p = this.$route.query
      let host = null
      if (p) {
        const { redirect } = p
        if (redirect) {
          host = redirect
        }
      }
      if (host === null) {
        host = window.location.protocol + '//' + window.location.host + '/home'
      }
      window.location.href = host
    },
    startCountDown () {
      const stopTimer = () => {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
      stopTimer()
      this.smsCodeCountDownSecond = 60
      this.timer = setInterval(() => {
        this.smsCodeCountDownSecond = this.smsCodeCountDownSecond - 1
        if (this.smsCodeCountDownSecond < 0) {
          stopTimer()
        }
      }, 1000)
    },
    sendLoginSMSCode () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      this.loading = true
      sendLoginSMSCode(phone).then(rsp => {
        this.loading = false
        const { code, message } = rsp
        this.loading = false
        if (code === 0) {
          this.$message.success('发送成功')
          this.startCountDown()
        } else {
          this.$message.error(message)
        }
      })
    },
    registerAction () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      const smsCode = this.smsCode.trim()
      if (smsCode.length === 0) {
        this.$message.error('验证码不能为空')
        return
      }
      const psw = this.password.trim()
      if (psw.length === 0) {
        this.$message.error('密码不能为空')
        return
      }
      this.loading = true
      postRegisterInfo(phone, smsCode, psw).then(rsp => {
        const {code, message} = rsp
        this.loading = false
        if (code === 0) {
          this.loginSuccess()
        } else {
          this.$message.error(message)
        }
      })
    },
    sendRegisterSMSCode () {
      const phone = this.account.trim()
      if (phone.length === 0) {
        this.$message.error('手机号不能为空')
        return
      }
      this.loading = true
      sendRegisterSMSCode(phone).then(rsp => {
        this.loading = false
        const { code, message } = rsp
        this.loading = false
        if (code === 0) {
          this.$message.success('发送成功')
          this.startCountDown()
        } else {
          this.$message.error(message)
        }
      })
    },
    switchLoginType () {
      this.loginType = (this.loginType + 1) % 2
    },
    switchLoginOrSignUp () {
      this.showLoginOrSignUp = !this.showLoginOrSignUp
    }
  }
}
</script>

<style scoped>
.login-container {
  background: rgba(66, 129, 255, 1);
  display: flex;
  flex: 1;
}
.login-background {
  background-image: url('login_bg.png');
  background-repeat:repeat-x;
  flex: 1;
  text-align: center;
}
.login-page-title {
  text-shadow: 0 2 8 rgba(0, 0, 0, 0.3);
  margin-top: 10rem;
  font-weight: bolder;
  color: rgba(255, 255, 255, 1);
  font-size: 6rem;
}
.login-input-content{
  display: flex;
  padding-top: 5rem;
  align-items: center;
  justify-content: center;
}
.login-input-content-bg{
  border-radius: 10px;
  width: 20rem;
  text-align: center;
  background-color: white;
  padding: 1.2rem 1.6rem 1.2rem 1.2rem;
}
.login-title{
  font-weight: bolder;
  font-size: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
}
.form-input{
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue